export const handleChangeDataModalLogOut = (name, value) => ({
    type: 'CHANGE_DATA_MODAL_LOG_OUT', name, value
});